import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import Config from '@/config'
import store from '@/store'
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_ROUTE_BASE,
  routes
})

router.beforeEach(async (to, from, next) => {
  console.log('to', to)
  if (to.query.lang === 'zh-CN' || to.query.lang === 'en-US') {
    Config.useI18n = to.query.lang
  }

  if (to.fullPath === '/login/mock' || to.fullPath === '/login') {
    next()
    return
  }

  if (!store.getters.token) {
    next({ path: '/login' })
    return
  }
  console.log('userInfo', store.getters.userInfo)
  if (!store.getters.userInfo) {
    await store.dispatch('user/getUserInfo')
  }
  next()
})

export default router
